import { render } from "./Listings.vue?vue&type=template&id=dae5e9c2"
import script from "./Listings.vue?vue&type=script&lang=js"
export * from "./Listings.vue?vue&type=script&lang=js"
script.render = render

export default script